import type { LoginAnomalyFlagName, FlagSeverity } from '../api/loginActivityApi'

export const FLAG_LABELS: Record<LoginAnomalyFlagName, string> = {
  multi_ip: 'Multiple IPs',
  multi_network: 'Multiple Networks',
  multi_country: 'Multiple Countries',
  impossible_travel: 'Impossible Travel',
  datacenter_origin: 'Datacenter Origin',
  high_abuse_score: 'High Abuse Score',
  unexpected_country: 'Unexpected Country',
}

export const SEVERITY_COLORS: Record<FlagSeverity, string> = {
  warning: 'red',
  informational: 'blue',
}

export function formatLocation(geo?: { city?: string; country?: string }): string {
  if (!geo || (!geo.city && !geo.country)) return '—'
  return [geo.city, geo.country].filter(Boolean).join(', ')
}
